import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  href,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  return <a href={href} target="_top" rel="noopener" className={`group inline-flex items-center justify-center gap-2 rounded-xl bg-flame text-center font-display font-extrabold uppercase tracking-tight text-white shadow-cta outline-none transition-[transform,background-color] duration-150 ease-smooth hover:bg-flame-600 focus-visible:ring-4 focus-visible:ring-flame/40 active:scale-[0.985] ${size === 'lg' ? 'px-7 py-4 text-base sm:text-lg' : 'px-5 py-3 text-sm'} ${className}`} data-id="element-10" data-mp="hhj26x77xry1">
      <span data-id="element-11" data-mp="19as3mttjl57c">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-12" data-mp="19c38kwyq4j01" />
    </a>;
}